import {
  ADD_SHP_DATA_REQUEST,
  ADD_SHP_DATA_SUCCESS,
  ADD_SHP_DATA_FAILURE,
  ADD_GML_DATA_REQUEST,
  ADD_GML_DATA_SUCCESS,
  ADD_GML_DATA_FAILURE,
  ADD_CSV_DATA_REQUEST,
  ADD_CSV_DATA_SUCCESS,
  ADD_CSV_DATA_FAILURE,
  ADD_SQLITE_DATA_REQUEST,
  ADD_SQLITE_DATA_SUCCESS,
  ADD_SQLITE_DATA_FAILURE,
  ADD_APPROVED_SQLITE_DATA_REQUEST,
  ADD_APPROVED_SQLITE_DATA_SUCCESS,
  ADD_APPROVED_SQLITE_DATA_FAILURE,
  FETCH_JOB_STATUS_REQUEST,
  FETCH_JOB_STATUS_SUCCESS,
  FETCH_JOB_STATUS_FAILURE,
  FETCH_POIS_REQUEST,
  FETCH_POIS_SUCCESS,
  FETCH_POIS_FAILURE,
  FETCH_HOTELS_REQUEST,
  FETCH_HOTELS_SUCCESS,
  FETCH_HOTELS_FAILURE,
  FETCH_POIS_PROPS_REQUEST, //fetches proposed pois
  FETCH_POIS_PROPS_SUCCESS,
  FETCH_POIS_PROPS_FAILURE,
  FETCH_HOTELS_PROPS_REQUEST, //fetches proposed hotels
  FETCH_HOTELS_PROPS_SUCCESS,
  FETCH_HOTELS_PROPS_FAILURE,
  POST_NEW_POI_REQUEST,
  POST_NEW_POI_SUCCESS,
  POST_NEW_POI_FAILURE,
  UPDATE_NEW_POI_REQUEST,
  UPDATE_NEW_POI_SUCCESS,
  UPDATE_NEW_POI_FAILURE,
  SAVE_NEW_POI_REQUEST,
  SAVE_NEW_POI_SUCCESS,
  SAVE_NEW_POI_FAILURE,
  DELETE_NEW_POI_REQUEST,
  DELETE_NEW_POI_SUCCESS,
  DELETE_NEW_POI_FAILURE,
  POST_NEW_HOTEL_REQUEST,
  POST_NEW_HOTEL_SUCCESS,
  POST_NEW_HOTEL_FAILURE,
  UPDATE_NEW_HOTEL_REQUEST,
  UPDATE_NEW_HOTEL_SUCCESS,
  UPDATE_NEW_HOTEL_FAILURE,
  DELETE_NEW_HOTEL_REQUEST,
  DELETE_NEW_HOTEL_SUCCESS,
  DELETE_NEW_HOTEL_FAILURE,
  SAVE_NEW_HOTEL_REQUEST,
  SAVE_NEW_HOTEL_SUCCESS,
  SAVE_NEW_HOTEL_FAILURE,
  FETCH_PARCEL_ID_REQUEST,
  FETCH_PARCEL_ID_SUCCESS,
  FETCH_PARCEL_ID_FAILURE,
  TOGGLE_ADDITIONALS,
  DISABLE_ADDITIONALS,
  DELETE_FORM_ATTR_REQUEST,
  DELETE_FORM_ATTR_SUCCESS,
  DELETE_FORM_ATTR_FAILURE,
  UPDATE_FORM_ATTR_REQUEST,
  UPDATE_FORM_ATTR_SUCCESS,
  UPDATE_FORM_ATTR_FAILURE,
  UPLOAD_PARCEL_SUCCESS,
} from '../constants';

const initialState = {
  isPostingSHP: false,
  isPostingGML: false,
  isPostingCSV: false,
  isPostingSQLite: false,
  isFetchingJobStatus: false,
  isFeatchingPois: false,
  isFeatchingPoisProps: false,
  isFeatchingHotels: false,
  isFeatchingHotelsProps: false,
  isSavingNewPoi: false,
  isSavingNewHotel: false,
  shpJobs: [],
  additionalLayers: {
    pois: {
      data: null,
      isVisible: true,
    },
    hotels: {
      data: null,
      isVisible: true,
    },
    pois_propozycje: {
      data: null,
      isVisible: true,
    },
    hotels_propozycje: {
      data: null,
      isVisible: true,
    },
  },
  parcel_id: null,
  parcel_data: null,
  isFetchingFormAttr: false,
};
//SHP
const addShpDataRequest = (state) => ({
  ...state,
  isPostingSHP: true,
});
const addShpDataSuccess = (state) => ({
  ...state,
  isPostingSHP: false,
});
const addShpDataFailure = (state) => ({
  ...state,
  isPostingSHP: false,
});
//GML
const addGmlDataRequest = (state) => ({
  ...state,
  isPostingGML: true,
});
const addGmlDataSuccess = (state) => ({
  ...state,
  isPostingGML: false,
});
const addGmlDataFailure = (state) => ({
  ...state,
  isPostingGML: false,
});
//CSV
const addCsvDataRequest = (state) => ({
  ...state,
  isPostingCSV: true,
});
const addCsvDataSuccess = (state) => ({
  ...state,
  isPostingCSV: false,
});
const addCsvDataFailure = (state) => ({
  ...state,
  isPostingCSV: false,
});
//SQLite
const addSQLiteDataRequest = (state) => ({
  ...state,
  isPostingSQLite: true,
});
const addSQLiteDataSuccess = (state) => ({
  ...state,
  isPostingSQLite: false,
});
const addSQLiteDataFailure = (state) => ({
  ...state,
  isPostingSQLite: false,
});
//Fetch job status
const fetchJobStatusRequest = (state) => ({
  ...state,
  isFetchingJobStatus: true,
});
const fetchJobStatusSuccess = (state) => ({
  ...state, // TODO: add concatenetion
  isFetchingJobStatus: false,
});
const fetchJobStatusFailure = (state) => ({
  ...state,
  isFetchingJobStatus: false,
});

//Fetch Pois
const fetchPoisRequest = (state) => ({
  ...state,
  isFeatchingPois: true,
});
const fetchPoisSuccess = (state, action) => ({
  ...state, // TODO: add concatenetion
  additionalLayers: {
    ...state.additionalLayers,
    pois: {
      ...state.additionalLayers.pois,
      data: action.payload,
    },
  },
  isFeatchingPois: false,
});
const fetchPoisFailure = (state) => ({
  ...state,
  isFeatchingPois: false,
});

//Fetch Hotels
const fetchHotelsRequest = (state) => ({
  ...state,
  isFeatchingHotels: true,
});
const fetchHotelsSuccess = (state, action) => ({
  ...state, // TODO: add concatenetion
  additionalLayers: {
    ...state.additionalLayers,
    hotels: {
      ...state.additionalLayers.hotels,
      data: action.payload,
    },
  },
  isFeatchingHotels: false,
});
const fetchHotelsFailure = (state) => ({
  ...state,
  isFeatchingHotels: false,
});

//Fetch Poi proposed
const fetchPoiPropsRequest = (state) => ({
  ...state,
  isFeatchingPoisProps: true,
});
const fetchPoiPropsSuccess = (state, action) => ({
  ...state, // TODO: add concatenetion
  additionalLayers: {
    ...state.additionalLayers,
    pois_propozycje: {
      ...state.additionalLayers.pois_propozycje,
      data: action.payload,
    },
  },
  isFeatchingPoisProps: false,
});

const fetchPoiPropsFailure = (state) => ({
  ...state,
  isFeatchingPoisProps: false,
});

//Fetch hotels proposed
const fetchHotelPropsRequest = (state) => ({
  ...state,
  isFeatchingHotelsProps: true,
});
const fetchHotelPropsSuccess = (state, action) => ({
  ...state, // TODO: add concatenetion
  additionalLayers: {
    ...state.additionalLayers,
    hotels_propozycje: {
      ...state.additionalLayers.hotels_propozycje,
      data: action.payload,
    },
  },
  isFeatchingHotelsProps: false,
});
const fetchHotelPropsFailure = (state) => ({
  ...state,
  isFeatchingHotelsProps: false,
});

//Fetch hotels proposed
const saveNewPoiRequest = (state) => ({
  ...state,
  isSavingNewPoi: true,
});
const saveNewPoiSuccess = (state, action) => ({
  ...state, // TODO: add concatenetion
  additionalLayers: {
    ...state.additionalLayers,
    pois_propozycje: {
      ...state.additionalLayers.pois_propozycje,
      data: action.payload.pois_propozycje,
    },
    pois: {
      ...state.additionalLayers.pois,
      data: action.payload.pois,
    },
  },
  isSavingNewPoi: false,
});
const saveNewPoiFailure = (state) => ({
  ...state,
  isSavingNewPoi: false,
});

//Fetch hotels proposed
const saveNewHotelRequest = (state) => ({
  ...state,
  isSavingNewHotel: true,
});
const saveNewHotelSuccess = (state, action) => ({
  ...state, // TODO: add concatenetion
  additionalLayers: {
    ...state.additionalLayers,
    hotels_propozycje: {
      ...state.additionalLayers.hotels_propozycje,
      data: action.payload.hotels_propozycje,
    },
    hotels: {
      ...state.additionalLayers.hotels,
      data: action.payload.hotels,
    },
  },
  isSavingNewHotel: false,
});
const saveNewHotelFailure = (state) => ({
  ...state,
  isSavingNewHotel: false,
});

const fetchFormAttrRequest = (state) => ({
  ...state,
  isFetchingFormAttr: true,
});
const fetchFormAttrSuccess = (state, action) => ({
  ...state,
  isFetchingFormAttr: false,
});

const fetchFormAttrFailure = (state) => ({
  ...state,
  isFetchingFormAttr: false,
});

const toggleAdditionals = (state, action) => ({
  ...state,
  additionalLayers: {
    ...state.additionalLayers,
    [action.payload.layerName]: {
      data: state.additionalLayers[action.payload.layerName].data,
      isVisible: !state.additionalLayers[action.payload.layerName].isVisible,
    },
  },
});

const disableAdditionals = (state) => ({
  ...state,
  additionalLayers: {
    pois: {
      data: state.additionalLayers.pois.data,
      isVisible: false,
    },
    hotels: {
      data: state.additionalLayers.hotels.data,
      isVisible: false,
    },
    pois_propozycje: {
      data: state.additionalLayers.pois_propozycje.data,
      isVisible: false,
    },
    hotels_propozycje: {
      data: state.additionalLayers.hotels_propozycje.data,
      isVisible: false,
    },
  },
});

const addParcel_Id = (state, action) => ({
  ...state,
  parcel_id: action.id,
  parcel_data: action.payload,
});

const addParcel_Up = (state, action) => ({
  ...state,
  parcel_id: null,
  parcel_data: action.payload,
});

export default function reducer(state = initialState, action) {
  return ({
    [ADD_SHP_DATA_REQUEST]: addShpDataRequest,
    [ADD_SHP_DATA_SUCCESS]: addShpDataSuccess,
    [ADD_SHP_DATA_FAILURE]: addShpDataFailure,
    [ADD_GML_DATA_REQUEST]: addGmlDataRequest,
    [ADD_GML_DATA_SUCCESS]: addGmlDataSuccess,
    [ADD_GML_DATA_FAILURE]: addGmlDataFailure,
    [ADD_CSV_DATA_REQUEST]: addCsvDataRequest,
    [ADD_CSV_DATA_SUCCESS]: addCsvDataSuccess,
    [ADD_CSV_DATA_FAILURE]: addCsvDataFailure,
    [ADD_SQLITE_DATA_REQUEST]: addSQLiteDataRequest,
    [ADD_SQLITE_DATA_SUCCESS]: addSQLiteDataSuccess,
    [ADD_SQLITE_DATA_FAILURE]: addSQLiteDataFailure,
    [ADD_APPROVED_SQLITE_DATA_REQUEST]: addSQLiteDataRequest,
    [ADD_APPROVED_SQLITE_DATA_SUCCESS]: addSQLiteDataSuccess,
    [ADD_APPROVED_SQLITE_DATA_FAILURE]: addSQLiteDataFailure,
    [FETCH_JOB_STATUS_REQUEST]: fetchJobStatusRequest,
    [FETCH_JOB_STATUS_SUCCESS]: fetchJobStatusSuccess,
    [FETCH_JOB_STATUS_FAILURE]: fetchJobStatusFailure,

    [FETCH_POIS_REQUEST]: fetchPoisRequest,
    [FETCH_POIS_SUCCESS]: fetchPoisSuccess,
    [FETCH_POIS_FAILURE]: fetchPoisFailure,
    [FETCH_HOTELS_REQUEST]: fetchHotelsRequest,
    [FETCH_HOTELS_SUCCESS]: fetchHotelsSuccess,
    [FETCH_HOTELS_FAILURE]: fetchHotelsFailure,

    [FETCH_POIS_PROPS_REQUEST]: fetchPoiPropsRequest,
    [FETCH_POIS_PROPS_SUCCESS]: fetchPoiPropsSuccess,
    [FETCH_POIS_PROPS_FAILURE]: fetchPoiPropsFailure,
    [FETCH_HOTELS_PROPS_REQUEST]: fetchHotelPropsRequest,
    [FETCH_HOTELS_PROPS_SUCCESS]: fetchHotelPropsSuccess,
    [FETCH_HOTELS_PROPS_FAILURE]: fetchHotelPropsFailure,

    [POST_NEW_POI_REQUEST]: fetchPoiPropsRequest,
    [POST_NEW_POI_SUCCESS]: fetchPoiPropsSuccess,
    [POST_NEW_POI_FAILURE]: fetchPoiPropsFailure,
    [UPDATE_NEW_POI_REQUEST]: fetchPoiPropsRequest,
    [UPDATE_NEW_POI_SUCCESS]: fetchPoiPropsSuccess,
    [UPDATE_NEW_POI_FAILURE]: fetchPoiPropsFailure,
    [DELETE_NEW_POI_REQUEST]: fetchPoiPropsRequest,
    [DELETE_NEW_POI_SUCCESS]: fetchPoiPropsSuccess,
    [DELETE_NEW_POI_FAILURE]: fetchPoiPropsFailure,
    [SAVE_NEW_POI_REQUEST]: saveNewPoiRequest,
    [SAVE_NEW_POI_SUCCESS]: saveNewPoiSuccess,
    [SAVE_NEW_POI_FAILURE]: saveNewPoiFailure,

    [POST_NEW_HOTEL_REQUEST]: fetchHotelPropsRequest,
    [POST_NEW_HOTEL_SUCCESS]: fetchHotelPropsSuccess,
    [POST_NEW_HOTEL_FAILURE]: fetchHotelPropsFailure,
    [UPDATE_NEW_HOTEL_REQUEST]: fetchHotelPropsRequest,
    [UPDATE_NEW_HOTEL_SUCCESS]: fetchHotelPropsSuccess,
    [UPDATE_NEW_HOTEL_FAILURE]: fetchHotelPropsFailure,
    [DELETE_NEW_HOTEL_REQUEST]: fetchHotelPropsRequest,
    [DELETE_NEW_HOTEL_SUCCESS]: fetchHotelPropsSuccess,
    [DELETE_NEW_HOTEL_FAILURE]: fetchHotelPropsFailure,
    [SAVE_NEW_HOTEL_REQUEST]: saveNewHotelRequest,
    [SAVE_NEW_HOTEL_SUCCESS]: saveNewHotelSuccess,
    [SAVE_NEW_HOTEL_FAILURE]: saveNewHotelFailure,
    [POST_NEW_POI_REQUEST]: fetchPoiPropsRequest,
    [POST_NEW_POI_SUCCESS]: fetchPoiPropsSuccess,
    [POST_NEW_POI_FAILURE]: fetchPoiPropsFailure,
    [FETCH_PARCEL_ID_SUCCESS]: addParcel_Id,
    [UPLOAD_PARCEL_SUCCESS]: addParcel_Up,
    [TOGGLE_ADDITIONALS]: toggleAdditionals,
    [DISABLE_ADDITIONALS]: disableAdditionals,
    [DELETE_FORM_ATTR_REQUEST]: fetchFormAttrRequest,
    [DELETE_FORM_ATTR_SUCCESS]: fetchFormAttrSuccess,
    [DELETE_FORM_ATTR_FAILURE]: fetchFormAttrFailure,
    [UPDATE_FORM_ATTR_REQUEST]: fetchFormAttrRequest,
    [UPDATE_FORM_ATTR_SUCCESS]: fetchFormAttrSuccess,
    [UPDATE_FORM_ATTR_FAILURE]: fetchFormAttrFailure,
  }[action.type] || (s => s)) (state, action);
}



// WEBPACK FOOTER //
// src/reducers/postGeoData.js